export const ProviderComposer = ({ providers = [], children }) =>
  providers.reduceRight(
    (acc, [Provider, ProviderProps]) => (
      <Provider { ...ProviderProps }>{acc}</Provider>
    ),
    children
  )
